export const underConstructionData = {
  title: 'Coming soon',
  standFirst: 'This page is currently under construction and will be available soon',
  bodyCopy: [],
}
